import EndpointCard from './EndpointCard';
import { EndpointCardProps, EndpointCardValueProps } from './types';

export type { EndpointCardProps, EndpointCardValueProps };
export default EndpointCard;
